import React, { useState } from "react";
import "rc-switch/assets/index.css";
import Switch from "rc-switch";
import Table from "rc-table";

interface RoomProps {
  data: any;
  Auth: any;
}

const Rooms: React.FC<RoomProps> = ({ data, Auth }) => {
  const [checked, setChecked] = useState(false);

  const columns = [
    {
      title: "Room",
      dataIndex: "Room",
      key: "Room",
      width: 250,
    },
    {
      title: "Dimensions",
      dataIndex: "Dimensions",
      key: "Dimensions",
      width: 250,
      render: (number: number[]) =>
        checked
          ? `${number[0]} X ${number[1]} m`
          : `${(number[0] * 3.28084).toFixed(2)} X ${(
              number[1] * 3.28084
            ).toFixed(2)} ft`,
    },
    {
      title: "Features",
      dataIndex: "Features",
      key: "Features",
      width: 350,

      render: (tags: any[]) => (
        <>
          <div className="flex flex-wrap gap-2">
            {tags.map((item: string, index: number) => {
              return (
                item && (
                  <div
                    className="bg-gray-100 px-3 border border-gray-200"
                    key={index + 1}
                  >
                    <div>{item}</div>
                  </div>
                )
              );
            })}
          </div>
        </>
      ),
    },
  ];

  let TableData = [];

  for (let index = 1; index <= 12; index++) {
    const _room = data[`Rm${index}_out`];
    if (_room !== "") {
      TableData.push({
        key: index + 1,
        Room: _room,
        Dimensions: [
          data[`Rm${index}_len`] || 0.0,
          data[`Rm${index}_wth`] || 0.0,
        ],
        Features: [
          data[`Rm${index}_dc1_out`],
          data[`Rm${index}_dc2_out`],
          data[`Rm${index}_dc3_out`],
        ],
      });
    }
  }

  return (
    <div>
      <div>
        <div className="flex flex-col gap-5 flex-wrap pt-2">
          <div className="flex justify-between">
            <h4 className="text-lg font-normal">Rooms</h4>
            <div className="flex gap-2">
              <p>Metric</p>
              <Switch onChange={(v) => setChecked(v)} />
              <p>Imperial</p>
            </div>
          </div>
          <hr />
          <div
            className={`text-sm text-justify ${
              data.Lock && !Auth.verify ? "blur-sm select-none" : ""
            }`}
          >
            <Table className="roomTable" data={TableData} columns={columns} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rooms;
